import { Component } from 'preact';
import type { ComponentChildren } from 'preact';

type Props = { children: ComponentChildren };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static override getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(err: Error): void {
    console.error('App error:', err);
  }

  override render() {
    if (this.state.error) {
      return (
        <main style={{ padding: 32, fontFamily: 'system-ui' }}>
          <h2 style={{ color: 'var(--loss)' }}>Something went wrong</h2>
          <pre
            style={{
              color: 'var(--ink-2)',
              fontSize: 12,
              marginTop: 16,
              overflow: 'auto',
            }}
          >
            {this.state.error.message}
          </pre>
          <button
            style={{
              marginTop: 16,
              padding: '8px 16px',
              background: 'var(--accent)',
              color: 'white',
              borderRadius: 8,
            }}
            onClick={() => window.location.reload()}
          >
            Reload
          </button>
        </main>
      );
    }
    return this.props.children;
  }
}
